// extracted by mini-css-extract-plugin
export var actionButton = "_e0-0";
export var attachmentLine = "_e0-1";
export var fileInput = "_e0-2";
export var fileUploadWrapper = "_e0-4";
export var footer = "_e0-3";
export var modalContent = "_e0-5";
export var paperclip = "_e0-6";
export var quillEditor = "_e0-7";